module.exports = __webpack_public_path__ + "assets/img/returnBtn-1b75d2eb.png";